import { CheckCircle2, Lock } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface Phase3IntroProps {
  commitMode?: boolean;
}

export const Phase3Intro = ({ commitMode }: Phase3IntroProps) => {
  return (
    <div className="flex items-center gap-3 py-2">
      <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center shrink-0">
        <CheckCircle2 className="h-5 w-5 text-primary" />
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <h2 className="text-xl font-semibold tracking-tight">Optionen bewerten</h2>
          {commitMode && (
            <Badge variant="outline" className="text-[10px] gap-1 bg-primary/10 text-primary border-primary/30">
              <Lock className="h-2.5 w-2.5" />
              Commitment
            </Badge>
          )}
        </div>
        <p className="text-sm text-muted-foreground">
          {commitMode 
            ? "Bewerte die Optionen gegen dein Phase-1-Commitment – dauert 30 Sekunden."
            : "Passe die Werte an, wo du anderer Meinung bist – dauert 30 Sekunden."
          }
        </p>
      </div>
    </div>
  );
};
